import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MercadoLibreInterface from './MercadoLibreApp';
import ConfirmationPage from '../pages/ConfirmationPage';
import SpecialCustomersPage from '../pages/SpecialCustomersPage';

const AppRoutes = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<MercadoLibreInterface />} />
                <Route path="/confirmation" element={<ConfirmationPage />} />
                <Route path="/clientes-especiales" element={<SpecialCustomersPage />} />
            </Routes>
        </Router>
    );
};

export default AppRoutes;
